import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
  state: () => ({
    isSupportDialogOpen: false,
    /**
     * Ganzseitiges dunkles Design im Look der Willkommensseite. Seiten, die
     * es brauchen (z. B. die Übersicht der Organisationseinstellungen),
     * setzen das Flag beim Betreten und nehmen es beim Verlassen zurück.
     */
    isDarkPage: false,
    /**
     * Anforderung, den Dialog „Fehler melden" vorbelegt zu öffnen – z. B. über
     * den Link „Support" in Fehlermeldungen (Kundenfeedback 16.10.2026, II).
     * `seq` macht wiederholte Anforderungen mit gleichem Text erkennbar.
     */
    bugReportRequest: null as null | { title: string; description: string; seq: number },
  }),

  actions: {
    setDarkPage(active: boolean) {
      this.isDarkPage = active;
    },

    openSupportDialog() {
      this.isSupportDialogOpen = true;
    },

    openBugReport(prefill: { title: string; description: string }) {
      this.bugReportRequest = { ...prefill, seq: (this.bugReportRequest?.seq ?? 0) + 1 };
    },

    closeSupportDialog() {
      this.isSupportDialogOpen = false;
    },
  },
});
